import React from "react";
import { List, Card, Grid, Button, Message } from "semantic-ui-react";
import { dispatch } from "@rematch/core/";
import { singleLineText, multiLineText } from "../../../../common/RegexValidation";
import { Form, Dropdown } from 'formsy-semantic-ui-react';
import TextEditor from "../../../../common/TextEditor";
import { withRouter } from 'react-router-dom';
import { history } from "../../../../../helpers";

class NewEmailTemplate extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            bodyText: '',
            isJSONValid: true
        }
    }
    updateText = (data, name) => {
        if (name === "Body Text") {

        }
    }
    cancel = () => {
        dispatch.customTemplates.setCustomNotificationRuleName(null);
        dispatch.customTemplates.setCustomNotificationCondition(null);
        history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_wsSetting/emailTemplates/listing`)
    }

    onSubmitNewTemplate = (data) => {
        let templateId = this.props.match.params.templateId;
        if (templateId === 'new') {
            dispatch.customTemplates.addEmailTemplate(data);
        } else {
            let templateObj = {
                "templateId": templateId,
                "template": data
            }
            dispatch.customTemplates.updateEmailTemplate(templateObj);
        }
    }

    IsValidJSONString = (e, data) => {
        try {
            JSON.parse(e.target.value);
        } catch (e) {
            this.setState({ "isJSONValid": false });
            return false;
        }
        this.setState({ "isJSONValid": true });
        return true
    }
    render() {
        const errorLabel = <div className="customErrorLabel" />;

        const heading = <div> {this.props.match.params.templateId === 'new' ? "Add" : "Edit"} Email Template <br /></div>
        return (
            <div className="general-setting">
                <div className=" overflow-auto h_100">
                    {heading}
                    <Form noValidate
                        ref={ref => this.form = ref}
                        className="formcyForm"
                        name="cretePack"
                        id="cretePackID"
                        onValidSubmit={(event) => { this.onSubmitNewTemplate(event) }}
                    >
                        <Grid style={{
                            backgroundColor: "#F3F8FB",
                            padding: "10px",
                            margin: "10px 0",
                            borderRadius: "5px"
                        }}>
                            <Grid.Row className="pad_b_0 pad_t_10" >
                                <Grid.Column width={16}>
                                    <Form.Input
                                        required
                                        name="name"
                                        id="Email Rule name"
                                        label="Email Rule name"
                                        placeholder="Add name"
                                        validations={{ matchRegexp: singleLineText }}
                                        errorLabel={errorLabel}
                                        value={this.props.customNotificationRuleName}
                                        validationErrors={{
                                            matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                            isDefaultRequiredValue: 'Email Rule name is required',
                                        }}
                                        instantValidation
                                        autoFocus
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            {/* <Grid.Row className="pad_b_0 pad_t_10">
                                <Grid.Column width={5}>
                                    <label>Service Name</label>
                                    <Dropdown
                                        name="servicename"
                                        placeholder="Select"
                                        search
                                        selection
                                        required
                                        validationErrors={{
                                            isDefaultRequiredValue: 'Service Name is required',
                                        }}
                                        errorLabel={errorLabel}
                                        options={[{ text: "Playbook" }, { text: "Initiative" }]}
                                    //onChange={(data, value) => { this.updatePriority(data, value) }}
                                    />
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <label>Event Name</label>
                                    <Dropdown
                                        name="eventName"
                                        placeholder="Select"
                                        search
                                        selection
                                        required
                                        validationErrors={{
                                            isDefaultRequiredValue: 'Event Name is required',
                                        }}
                                        errorLabel={errorLabel}
                                        options={[{ text: "Invite" }, { text: "Create" }]}
                                    //onChange={(data, value) => { this.updatePriority(data, value) }}
                                    />

                                </Grid.Column>
                            </Grid.Row> */}
                            <Grid.Row className="pad_b_0 pad_t_10">
                                {/* <Grid.Column width={5}>

                                    <Form.TextArea
                                        name="Recipients"
                                        label="Recipients"
                                        id="Recipients"
                                        value={this.props.description}
                                        errorLabel={errorLabel}
                                        validations={{ matchRegexp: multiLineText }}
                                        validationErrors={{
                                            matchRegexp: 'Max limit is 512. No space allowed in starting.',
                                            isDefaultRequiredValue: 'Description is required.',
                                        }}
                                        instantValidation
                                    />
                                </Grid.Column> */}
                                <Grid.Column width={10}>

                                    <Form.TextArea
                                        required
                                        name="rule"
                                        label="Condition"
                                        id="Condition"
                                        onChange={(e, data) => this.IsValidJSONString(e, data)}
                                        value={this.props.customNotificationCondition}
                                        errorLabel={errorLabel}
                                        style={{ minHeight: "300px" }}
                                        // validations={{ matchRegexp: multiLineText}}
                                        // validationErrors={{
                                        //     matchRegexp: 'Invalid JSON',
                                        //     isDefaultRequiredValue: 'Invalid JSON',
                                        // }}
                                        instantValidation
                                    />
                                    {!this.state.isJSONValid ?
                                        <Message className="bg-warning"
                                            style={{
                                                float: "left",
                                                padding: "8px",
                                                width: "calc(100% - 200px)",
                                                textAlign: "center"
                                            }}
                                            content='Please enter valid JSON'
                                        /> : null}
                                </Grid.Column>
                            </Grid.Row>
                            {/* <Grid.Row className="pad_b_0 pad_t_10" >
                                <Grid.Column width={16}>
                                    <Form.Input
                                        required
                                        name="Email Subject"
                                        id="Email Subject"
                                        label="Email Subject"
                                        placeholder="Add Subject"
                                        validations={{ matchRegexp: singleLineText }}
                                        errorLabel={errorLabel}
                                        validationErrors={{
                                            matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                            isDefaultRequiredValue: 'Email Subject is required',
                                        }}
                                        instantValidation
                                        autoFocus
                                    />
                                </Grid.Column>
                            </Grid.Row> */}
                            {/* <Grid.Row className="pad_b_0 pad_t_10" >
                                <Grid.Column width={16}>
                                    <TextEditor
                                        name="Body Text"
                                        text={this.state.bodyText}
                                        type="textarea"
                                        onChangeText={this.updateText}
                                        requiredValue={true}
                                    />
                                </Grid.Column>
                            </Grid.Row> */}
                        </Grid>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={16} className="actionInFormcy border-none" >
                                    <Button disabled={!this.state.isJSONValid} floated='right' id="savebtn" className="button-submit" type="submit">Save</Button>
                                    <Button floated='right' className="button-cancel" id="cancelbtn" onClick={this.cancel}>Cancel</Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                </div>
            </div>
        );
    }
}


export default withRouter(NewEmailTemplate);